import React, { useEffect, useRef, useState } from 'react'
import ship from "../../assets/images/design/ship.svg"
import timeline from "../../assets/images/design/about-timeline.svg"
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectLanguage } from '../../redux/language/selector'

const AboutTimeline = () => {
    const { t } = useTranslation()
    const language = useSelector(selectLanguage)

    const values = [
        {
            key: 1,
            month: t('about-us.time-line.sept'),
            year: "2016",
            info: t('about-us.time-line.2016-sept')
        },
        {
            key: 2,
            month: t('about-us.time-line.apr'),
            year: "2017",
            info: t('about-us.time-line.2017-apr')
        },
        {
            key: 3,
            month: t('about-us.time-line.nov'),
            year: "2017",
            info: t('about-us.time-line.2017-nov')
        },
        {
            key: 4,
            month: t('about-us.time-line.jan'),
            year: "2018",
            info: t('about-us.time-line.2018-jan')
        },
        {
            key: 5,
            month: t('about-us.time-line.mar'),
            year: "2018",
            info: t('about-us.time-line.2018-mar')
        },
        {
            key: 6,
            month: t('about-us.time-line.jul'),
            year: "2018",
            info: t('about-us.time-line.2018-jul')
        },
        {
            key: 7,
            month: t('about-us.time-line.may'),
            year: "2019",
            info: t('about-us.time-line.2019-may')
        },
        {
            key: 8,
            month: t('about-us.time-line.jul'),
            year: "2019",
            info: t('about-us.time-line.2019-jul')
        },
        {
            key: 9,
            month: t('about-us.time-line.oct'),
            year: "2019",
            info: t('about-us.time-line.2019-oct')
        },
        {
            key: 10,
            month: t('about-us.time-line.nov'),
            year: "2019",
            info: t('about-us.time-line.2019-nov')
        },
        {
            key: 11,
            month: t('about-us.time-line.dec'),
            year: "2019",
            info: t('about-us.time-line.2019-dec')
        },
        {
            key: 12,
            month: t('about-us.time-line.apr'),
            year: "2020",
            info: t('about-us.time-line.2020-apr-1')
        },
        {
            key: 13,
            month: t('about-us.time-line.apr'),
            year: "2020",
            info: t('about-us.time-line.2020-apr-2')
        },
        {
            key: 14,
            month: t('about-us.time-line.may'),
            year: "2020",
            info: t('about-us.time-line.2020-may')
        },
        {
            key: 15,
            month: t('about-us.time-line.jul'),
            year: "2020",
            info: t('about-us.time-line.2020-jul-1')
        },
        {
            key: 16,
            month: t('about-us.time-line.jul'),
            year: "2020",
            info: t('about-us.time-line.2020-jul-2')
        },
        {
            key: 17,
            month: t('about-us.time-line.nov'),
            year: "2020",
            info: t('about-us.time-line.2020-nov')
        },
        {
            key: 18,
            month: t('about-us.time-line.dec'),
            year: "2020",
            info: t('about-us.time-line.2020-dec')
        },
        {
            key: 19,
            month: t('about-us.time-line.mar'),
            year: "2021",
            info: t('about-us.time-line.2021-mar-1')
        },
        {
            key: 20,
            month: t('about-us.time-line.mar'),
            year: "2021",
            info: t('about-us.time-line.2021-mar-2')
        },
        {
            key: 21,
            month: t('about-us.time-line.apr'),
            year: "2021",
            info: t('about-us.time-line.2021-apr')
        },
        {
            key: 22,
            month: t('about-us.time-line.sept'),
            year: "2021",
            info: t('about-us.time-line.2021-sept')
        },
        {
            key: 23,
            month: t('about-us.time-line.jan'),
            year: "2022",
            info: t('about-us.time-line.2022-jan-1')
        },
        {
            key: 24,
            month: t('about-us.time-line.jan'),
            year: "2022",
            info: t('about-us.time-line.2022-jan-2')
        },
        {
            key: 25,
            month: t('about-us.time-line.jan'),
            year: "2022",
            info: t('about-us.time-line.2022-jan-3')
        },
        {
            key: 26,
            month: t('about-us.time-line.jan'),
            year: "2022",
            info: t('about-us.time-line.2022-jan-4')
        },
        {
            key: 27,
            month: t('about-us.time-line.mar'),
            year: "2022",
            info: t('about-us.time-line.2022-mar-1')
        },
        {
            key: 28,
            month: t('about-us.time-line.mar'),
            year: "2022",
            info: t('about-us.time-line.2022-mar-2')
        },
        {
            key: 29,
            month: t('about-us.time-line.mar'),
            year: "2022",
            info: t('about-us.time-line.2022-mar-3')
        },
        {
            key: 30,
            month: t('about-us.time-line.mar'),
            year: "2022",
            info: t('about-us.time-line.2022-mar-4')
        },
        {
            key: 31,
            month: t('about-us.time-line.mar'),
            year: "2022",
            info: t('about-us.time-line.2022-mar-5')
        },
        {
            key: 32,
            month: t('about-us.time-line.jul'),
            year: "2022",
            info: t('about-us.time-line.2022-jul')
        },
        {
            key: 33,
            month: t('about-us.time-line.dec'),
            year: "2022",
            info: t('about-us.time-line.2022-dec')
        },
        {
            key: 34,
            month: t('about-us.time-line.mar'),
            year: "2023",
            info: t('about-us.time-line.2023-mar')
        },
        {
            key: 35,
            month: t('about-us.time-line.jun'),
            year: "2023",
            info: t('about-us.time-line.2023-jun')
        },
        {
            key: 36,
            month: t('about-us.time-line.oct'),
            year: "2023",
            info: t('about-us.time-line.2023-oct')
        },
    ]

    const [activeIndex, setActiveIndex] = useState(0);
    const [touchStartX, setTouchStartX] = useState(0);
    const [touchEndX, setTouchEndX] = useState(0);

    const handleItemClick = (index) => {
        setActiveIndex(index);
    };

    // function debounce(func, delay) {
    //     let timeoutId;
    //     return function (...args) {
    //         clearTimeout(timeoutId);

    //         timeoutId = setTimeout(() => {
    //             func.apply(this, args);
    //         }, delay);
    //     };
    // }

    const getListItemClass = (index) => {
        if (index === activeIndex) {
            return 'active';
        } else if (index === activeIndex - 1) {
            return 'prev-step';
        } else if (index === activeIndex + 1) {
            return 'next-step';
        } else {
            return '';
        }
    };



    const getTranslateXValue = (index) => {
        const desktopValue = -420;
        const mobileValue = -270;
        return window.matchMedia("(max-width: 499px)").matches ? mobileValue * index : desktopValue * index;
    };

    const timelineRef = useRef(null);
    const mobileRef = useRef(null)

    useEffect(() => {
        const handleWheel = (e) => {
            e.preventDefault();
            const delta = e.deltaY > 0 ? 1 : -1;
            setActiveIndex((prevIndex) => Math.max(0, Math.min(values.length - 1, prevIndex + delta)));
        };

        const timelineElement = timelineRef.current;

        if (timelineElement) {
            timelineElement.addEventListener('wheel', handleWheel);

            return () => {
                timelineElement.removeEventListener('wheel', handleWheel);
            };
        }
    }, [setActiveIndex]);

    const handleTouchStart = (e) => {
        setTouchStartX(e.touches[0].clientX);
    };

    const handleTouchMove = (e) => {
        setTouchEndX(e.touches[0].clientX);
    };

    const handleTouchEnd = () => {
        const deltaX = touchEndX - touchStartX;
        if (Math.abs(deltaX) > 50) {
            if (deltaX > 0) {
                // Swipe right, decrease index
                setActiveIndex((prevIndex) => Math.max(0, prevIndex - 1));
            } else {
                // Swipe left, increase index
                setActiveIndex((prevIndex) => Math.min(values.length - 1, prevIndex + 1));
            }
        }
    };

    useEffect(() => {
        const mobileElement = mobileRef.current;

        if (mobileRef) {
            mobileElement.addEventListener('touchstart', handleTouchStart);
            mobileElement.addEventListener('touchmove', handleTouchMove);
            mobileElement.addEventListener('touchend', handleTouchEnd);

            return () => {
                mobileElement.removeEventListener('touchstart', handleTouchStart);
                mobileElement.removeEventListener('touchmove', handleTouchMove);
                mobileElement.removeEventListener('touchend', handleTouchEnd);
            };
        }
    }, [setActiveIndex, touchEndX, touchStartX])

    return (
        <div className="about__timeline" >
            <div className="container text-center pb-10">
                <p className="text-white font-weight-semi-bold font-30">{t('about-us.time-line.title')}</p>
            </div>
            <div className="timeline" id="timeline-aboutus" ref={mobileRef}>
                <img className="timeline__cursor ship" src={ship} alt="" />
                <ul className="timeline__steps"
                    style={{ transform: `translateX(${getTranslateXValue(activeIndex)}px` }}
                    ref={timelineRef}
                >
                    {values.map((value, index) => (
                        <li className={getListItemClass(index)} onClick={() => handleItemClick(index)} key={value.key}>
                            {language === "en"
                                ?
                                <span className="year font-lg bold">{value.year} {value.month}</span>
                                :
                                <span className="year font-lg bold">{value.month}/{value.year}</span>
                            }
                            <p className=''>{value.info}</p>
                        </li>
                    ))}

                </ul>
            </div>
            <img src={timeline} className="form" alt="" />
        </div>

    )
}

export default AboutTimeline